//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">WikiFX VPS产品分类</div>
                  <p class="title">
                      1、普通版（EA VPS）
                  </p>
                  <p>
                    配置：1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                    价格：$0.1USD
                  </p>
                  <p>
                      使用要求：开通后7日内需绑定实盘交易账户（任何交易商下的实盘账户均可），且至少有一笔交易（需至少有一笔平仓单）。否则会被回收。
                  </p>
                  <p>
                      续费条件：每个月至少有一笔实盘交易（至少有一笔平仓单）。
                  </p>
                  <p>
                      续费时长：到期前30日内满足续费条件后可续下一月。一次最多只能续一个月。
                  </p>
                  <p>
                      续费条件检测：登录web或app后查看。
                  </p>
                  <p class="t30 title">
                      2、专业版（EA VPS Pro）
                  </p>
                  <p>
                      配置：2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      价格：$6.99USD
                  </p>
                  <p>
                      使用要求：需绑定实盘交易账户（任何交易商下的实盘账户均可），且至少有一笔交易（需至少有一笔平仓单）。
                  </p>
                  <p>
                      续费条件：每个月至少有一笔实盘交易（至少有一笔平仓单）。
                  </p>
                  <p>
                      续费时长：到期前30日内满足续费条件后可续下一月。一次最多只能续一个月。
                  </p>
                  <p>
                      续费条件检测：登录web或app后查看。
                  </p>
                  <p class="t30 title">
                      3、cTrader版
                  </p>
                  <p>
                      配置：2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      价格：$16.99USD
                  </p>
                  <p>
                      使用要求：需绑定实盘交易账户（任何交易商下的实盘账户均可），且至少有一笔交易（需至少有一笔平仓单）。
                  </p>
                  <p>
                      续费条件：每个月至少有一笔实盘交易（至少有一笔平仓单）。
                  </p>
                  <p>
                      续费时长：到期前30日内满足续费条件后可续下一月。一次最多只能续一个月。
                  </p>
                  <p>
                      续费条件检测：登录web或app后查看。
                  </p>
                  <p class="t30 title">
                      4、专属版（EA VPS Plus）
                  </p>
                  <p>
                      配置：2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      价格：免费。首次开通需要支付开通费用。开通后可永久使用。
                  </p>
                  <p>
                      使用要求：需绑定该交易商实盘交易账户（其他交易商下的实盘账户无效），且至少有一笔交易（需至少有一笔平仓单）。
                  </p>
                  <p>
                    免费使用条件：每月至少1手（微型账户100手）该交易商的实盘交易; 近30日内有登录VPS
                  </p>
                  <p>
                      免费使用条件检测：登录Web或App后查看。
                  </p>`,
        zh: `
        <div class="title-box">WikiFX VPS產品分類</div>
                  <p class="title">
                      1、基礎版（EA VPS）
                  </p>
                  <p>
                      設定：1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      價格：$0.1USD
                  </p>
                  <p>
                      使用要求：開通後7日內需綁定實盤交易帳戶（任何交易商下的實盤帳戶均可），且至少有一筆交易（需至少有一筆平倉單）。 否則會被回收。
                  </p>
                  <p>
                      續約條件：每個月至少有一筆實盤交易（至少有一筆平倉單）。
                  </p>
                  <p>
                      續費時長：到期前30日內滿足續費條件後可續下一月。 一次最多只能續一個月。
                  </p>
                  <p>
                      續費條件檢測：登入web或app後查看。
                  </p>
                  <p class="t30 title">
                      2、高配版（EA VPS Pro）
                  </p>
                  <p>
                      設定：2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      價格：$6.99USD
                  </p>
                  <p>
                      使用要求：需綁定實盤交易帳戶（任何交易商下的實盤帳戶均可），且至少有一筆交易（需至少有一筆平倉單）。
                  </p>
                  <p>
                      續約條件：每個月至少有一筆實盤交易（至少有一筆平倉單）。
                  </p>
                  <p>
                      續費時長：到期前30日內滿足續費條件後可續下一月。 一次最多只能續一個月。
                  </p>
                  <p>
                      續費條件檢測：登入web或app後查看。
                  </p>
                  <p class="t30 title">
                      3、cTrader版
                  </p>
                  <p>
                      設定：2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      價格：$16.99USD
                  </p>
                  <p>
                      使用要求：需綁定實盤交易帳戶（任何交易商下的實盤帳戶均可），且至少有一筆交易（需至少有一筆平倉單）。
                  </p>
                  <p>
                      續約條件：每個月至少有一筆實盤交易（至少有一筆平倉單）。
                  </p>
                  <p>
                      續費時長：到期前30日內滿足續費條件後可續下一月。 一次最多只能續一個月。
                  </p>
                  <p>
                      續費條件檢測：登入web或app後查看。
                  </p>
                  <p class="t30 title">
                      4、專屬版（EA VPS Plus）
                  </p>
                  <p>
                      設定：2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      價格：免費。 首次開通需支付開通費用。 開通後可永久使用。
                  </p>
                  <p>
                      使用要求：需綁定該交易商實盤交易帳戶（其他交易商下的實盤帳戶無效），且至少有一筆交易（需至少有一筆平倉單）。
                  </p>
                  <p>
                    免費使用條件：每月至少1手（微型帳戶100手）該交易商的實盤交易; 近30日內有登入VPS
                  </p>
                  <p>
                      免費使用條件檢測：登入Web或App後查看。
                  </p>`,
        en: `
        <div class="title-box">WikiFX VPS product classification</div>
                          <p class="bold title">
                              1、Basic version (EA VPS)
                          </p>
                  <p>
                      Configuration: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Price: $0.1USD
                  </p>
                  <p>
                      Requirements for use: A real trading account must be bound within 7 days after opening (a real trading account under any dealer is acceptable), and there must be at least one transaction (at least one closing order is required). Otherwise it will be recycled.
                  </p>
                  <p>
                      Renewal conditions: at least one real transaction (at least one closing order) every month.
                  </p>
                  <p>
                      Renewal period: You can renew for the next month if you meet the renewal conditions within 30 days before expiration. It can only be renewed for a maximum of one month at a time.
                  </p>
                  <p>
                      Renewal condition detection: Check after logging in to the web or app.
                  </p>

                          <p class="bold t30 title">
                              2、High-end version (EA VPS Pro)
                          </p>
                  <p>
                      Configuration: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Price: $6.99USD
                  </p>
                  <p>
                      Requirements for use: A real trading account must be bound (a real trading account under any dealer is acceptable), and there must be at least one transaction (at least one closing order is required).
                  </p>
                  <p>
                      Renewal conditions: at least one real transaction (at least one closing order) every month.
                  </p>
                  <p>
                      Renewal period: You can renew for the next month if you meet the renewal conditions within 30 days before expiration. It can only be renewed for a maximum of one month at a time.
                  </p>
                  <p>
                      Renewal condition detection: Check after logging in to the web or app.
                  </p>

                          <p class="bold t30 title">
                              3、cTrader version
                          </p>
                  <p>
                      Configuration: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Price: $16.99USD
                  </p>
                  <p>
                      Requirements for use: A real trading account must be bound (a real trading account under any dealer is acceptable), and there must be at least one transaction (at least one closing order is required).
                  </p>
                  <p>
                      Renewal conditions: at least one real transaction (at least one closing order) every month.
                  </p>
                  <p>
                      Renewal period: You can renew for the next month if you meet the renewal conditions within 30 days before expiration. It can only be renewed for a maximum of one month at a time.
                  </p>
                  <p>
                      Renewal condition detection: Check after logging in to the web or app.
                  </p>

                          <p class="bold t30 title">
                              4、Exclusive version (EA VPS Plus)
                          </p>
                  <p>
                      Configuration: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Price: Free. There is an activation fee required to activate for the first time. It can be used permanently after activation.
                  </p>
                  <p>
                      Requirements for use: The broker&#39;s real trading account must be bound (real trading accounts under other traders are invalid), and there must be at least one transaction (at least one closing order is required).
                  </p>
                  <p>
                    Free usage conditions: at least 1 lot per month (100 lots for micro accounts) of the broker’s real trading; logged in to VPS in the past 30 days
                  </p>
                  <p>
                      Free usage condition detection: check after logging in to the Web or App.
                  </p>`,
        ru: `
        <div class="title-box">Классификация продуктов WikiFX VPS</div>
                          <p class="bold title">
                              1、Базовая версия (EA VPS)
                          </p>
                  <p>
                      Конфигурация: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Цена: $0.1USD
                  </p>
                  <p>
                      Требования к использованию: Реальный торговый счет должен быть привязан в течение 7 дней после открытия (допускается реальный торговый счет под любым дилером), и должна быть хотя бы одна сделка (необходим хотя бы один ордер на закрытие). В противном случае он будет переработан.
                  </p>
                  <p>
                      Условия продления: минимум одна реальная транзакция (минимум один ордер на закрытие) каждый месяц.
                  </p>
                  <p>
                      Период продления: вы можете продлить подписку на следующий месяц, если вы выполните условия продления в течение 30 дней до истечения срока действия. Его можно продлить максимум на один месяц за раз.
                  </p>
                  <p>
                      Обнаружение условий продления: проверьте после входа в Интернет или приложение.
                  </p>

                          <p class="bold t30 title">
                              2、Высококачественная версия (EA VPS Pro)
                          </p>
                  <p>
                      Конфигурация: 2*CPU，2G*RAM，60G*HDD，1M*ADSL.
                  </p>
                  <p>
                      Цена: $6.99USD.
                  </p>
                  <p>
                      Требования к использованию: Должен быть привязан реальный торговый счет (допускается реальный торговый счет под любым дилером), а также должна быть хотя бы одна сделка (необходим хотя бы один ордер на закрытие).
                  </p>
                  <p>
                      Условия продления: минимум одна реальная транзакция (минимум один ордер на закрытие) каждый месяц.
                  </p>
                  <p>
                      Период продления: вы можете продлить подписку на следующий месяц, если вы выполните условия продления в течение 30 дней до истечения срока действия. Его можно продлить максимум на один месяц за раз.
                  </p>
                  <p>
                      Обнаружение условий продления: проверьте после входа в Интернет или приложение.
                  </p>

                          <p class="bold t30 title">
                              3、Версия cTrader
                          </p>
                  <p>
                      Конфигурация: 2*CPU，4G*RAM，100G*HDD，2M*ADSL.
                  </p>
                  <p>
                      Цена: $16.99USD.
                  </p>
                  <p>
                      Требования к использованию: Должен быть привязан реальный торговый счет (допускается реальный торговый счет под любым дилером), а также должна быть хотя бы одна сделка (необходим хотя бы один ордер на закрытие).
                  </p>
                  <p>
                      Условия продления: минимум одна реальная транзакция (минимум один ордер на закрытие) каждый месяц.
                  </p>
                  <p>
                      Период продления: вы можете продлить подписку на следующий месяц, если вы выполните условия продления в течение 30 дней до истечения срока действия. Его можно продлить максимум на один месяц за раз.
                  </p>
                  <p>
                      Обнаружение условий продления: проверьте после входа в Интернет или приложение.
                  </p>

                          <p class="bold t30 title">
                              4、Эксклюзивная версия (EA VPS Plus)
                          </p>
                  <p>
                      Конфигурация: 2*CPU，2G*RAM，60G*HDD，2M*ADSL.
                  </p>
                  <p>
                      Цена: Бесплатно. Для первой активации необходимо внести плату за активацию. После активации его можно использовать постоянно.
                  </p>
                  <p>
                      Требования к использованию: Реальный торговый счет брокера должен быть привязан (реальные торговые счета других трейдеров недействительны), а также должна быть хотя бы одна транзакция (необходим хотя бы один ордер на закрытие).
                  </p>
                  <p>
                    Условия бесплатного использования: не менее 1 лота в месяц (100 лотов для микросчетов) реальной торговли брокера, зарегистрированного на VPS за последние 30 дней;
                  </p>
                  <p>
                      Бесплатное определение условий использования: проверьте после входа в Интернет или приложение.&nbsp;
                  </p>`,
        ja: `
        <div class="title-box">WikiFX VPS 製品分類</div>
                  <p class="bold title">
                      1、ベーシック版（EA VPS）
                  </p>
                  <p>
                      設定: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      価格：$0.1USD
                  </p>
                  <p>
                      使用要件: 実際の取引口座は開設後 7 日以内にバインドされている必要があり (どのディーラーの実際の取引口座でも可)、少なくとも 1 つの取引が必要です (少なくとも 1 つの決済注文が必要です)。 それ以外の場合はリサイクルされます。
                  </p>
                  <p>
                      更新条件: 毎月少なくとも 1 つの実際の取引 (少なくとも 1 つの決済注文)。
                  </p>
                  <p>
                      更新期間：有効期限の30日前までに更新条件を満たしていれば翌月の更新が可能です。 更新できる期間は一度に最大 1 か月までです。
                  </p>
                  <p>
                      更新条件検知：Webまたはアプリにログイン後に確認します。
                  </p>

                          <p class="bold t30 title">
                              2、ハイエンド版（EA VPS Pro）
                          </p>
                  <p>
                      設定: 2*CPU，2G*RAM，60G*HDD，1M*ADSL。
                  </p>
                  <p>
                      価格：$6.99USD
                  </p>
                  <p>
                      使用要件: 実際の取引口座がバインドされている必要があり (どのディーラーの実際の取引口座でも可)、少なくとも 1 つの取引が必要です (少なくとも 1 つの決済注文が必要です)。
                  </p>
                  <p>
                      更新条件: 毎月少なくとも 1 つの実際の取引 (少なくとも 1 つの決済注文)。
                  </p>
                  <p>
                      更新期間：有効期限の30日前までに更新条件を満たしていれば翌月の更新が可能です。 更新できる期間は一度に最大 1 か月までです。
                  </p>
                  <p>
                      更新条件検知：Webまたはアプリにログイン後に確認します。
                  </p>
                  <p class="bold title t30">
                      3、cTraderのバージョン
                  </p>
                  <p>
                      設定: 2*CPU，4G*RAM，100G*HDD，2M*ADSL。
                  </p>
                  <p>
                      価格：$16.99USD
                  </p>
                  <p>
                      使用要件: 実際の取引口座がバインドされている必要があり (どのディーラーの実際の取引口座でも可)、少なくとも 1 つの取引が必要です (少なくとも 1 つの決済注文が必要です)。
                  </p>
                  <p>
                      更新条件: 毎月少なくとも 1 つの実際の取引 (少なくとも 1 つの決済注文)。
                  </p>
                  <p>
                      更新期間：有効期限の30日前までに更新条件を満たしていれば翌月の更新が可能です。 更新できる期間は一度に最大 1 か月までです。
                  </p>
                  <p>
                      更新条件検知：Webまたはアプリにログイン後に確認します。
                  </p>

                          <p class="bold t30 title">
                              4、専用バージョン（EA VPS Plus）
                          </p>
                  <p>
                      設定: 2*CPU，2G*RAM，60G*HDD，2M*ADSL。
                  </p>
                  <p>
                      価格：無料。 初回アクティベーションにはアクティベーション料金が必要です。 アクティベーション後は永続的に使用できます。
                  </p>
                  <p>
                      使用要件: ブローカーの実際の取引口座はバインドされている必要があり (他のトレーダーの実際の取引口座は無効です)、少なくとも 1 つの取引が必要です (少なくとも 1 つの決済注文が必要です)。
                  </p>
                  <p>
                    無料使用の条件: 過去 30 日間にブローカーの実際の取引が少なくとも 1 つある (少なくとも 1 つのクローズ注文)。
                  </p>
                  <p>
                      無料利用状況検知：Webまたはアプリにログイン後に確認します。
                  </p>`,
        th: `
        <div class="title-box">การจำแนกประเภทผลิตภัณฑ์ WikiFX VPS</div>
                          <p class="bold title">
                              1、เวอร์ชันพื้นฐาน (EA VPS)
                          </p>
                  <p>
                      การกำหนดค่า: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      ราคา: $0.1USD
                  </p>
                  <p>
                      ข้อกำหนดสำหรับการใช้งาน: บัญชีซื้อขายจริงจะต้องถูกผูกไว้ภายใน 7 วันหลังจากเปิด (บัญชีซื้อขายจริงภายใต้ตัวแทนจำหน่ายใด ๆ เป็นที่ยอมรับ) และจะต้องมีอย่างน้อยหนึ่งธุรกรรม (ต้องมีคำสั่งปิดอย่างน้อยหนึ่งคำสั่ง) มิฉะนั้นจะถูกรีไซเคิล
                  </p>
                  <p>
                      เงื่อนไขการต่ออายุ: อย่างน้อยหนึ่งธุรกรรมจริง (อย่างน้อยหนึ่งคำสั่งปิด) ทุกเดือน
                  </p>
                  <p>
                      ระยะเวลาต่ออายุ: คุณสามารถต่ออายุได้ในเดือนถัดไปหากคุณตรงตามเงื่อนไขการต่ออายุภายใน 30 วันก่อนหมดอายุ สามารถต่ออายุได้สูงสุดครั้งละหนึ่งเดือนเท่านั้น
                  </p>
                  <p>
                      การตรวจสอบเงื่อนไขการต่ออายุ: ตรวจสอบหลังจากเข้าสู่เว็บหรือแอป
                  </p>

                          <p class="bold t30 title">
                              2、เวอร์ชันระดับไฮเอนด์ (EA VPS Pro)
                          </p>
                  <p>
                      การกำหนดค่า: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      ราคา: $6.99USD
                  </p>
                  <p>
                      ข้อกำหนดสำหรับการใช้งาน: จะต้องผูกบัญชีซื้อขายจริง (บัญชีซื้อขายจริงภายใต้ตัวแทนจำหน่ายใด ๆ เป็นที่ยอมรับ) และต้องมีธุรกรรมอย่างน้อยหนึ่งรายการ (ต้องมีคำสั่งปิดอย่างน้อยหนึ่งคำสั่ง)
                  </p>
                  <p>
                      เงื่อนไขการต่ออายุ: อย่างน้อยหนึ่งธุรกรรมจริง (อย่างน้อยหนึ่งคำสั่งปิด) ทุกเดือน
                  </p>
                  <p>
                      ระยะเวลาต่ออายุ: คุณสามารถต่ออายุได้ในเดือนถัดไปหากคุณตรงตามเงื่อนไขการต่ออายุภายใน 30 วันก่อนหมดอายุ สามารถต่ออายุได้สูงสุดครั้งละหนึ่งเดือนเท่านั้น
                  </p>
                  <p>
                      การตรวจสอบเงื่อนไขการต่ออายุ: ตรวจสอบหลังจากเข้าสู่เว็บหรือแอป
                  </p>

                          <p class="bold t30 title">
                              3、เวอร์ชัน cTrader
                          </p>
                  <p>
                      การกำหนดค่า: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      ราคา: $16.99USD
                  </p>
                  <p>
                      ข้อกำหนดสำหรับการใช้งาน: จะต้องผูกบัญชีซื้อขายจริง (บัญชีซื้อขายจริงภายใต้ตัวแทนจำหน่ายใด ๆ เป็นที่ยอมรับ) และต้องมีธุรกรรมอย่างน้อยหนึ่งรายการ (ต้องมีคำสั่งปิดอย่างน้อยหนึ่งคำสั่ง)
                  </p>
                  <p>
                      เงื่อนไขการต่ออายุ: อย่างน้อยหนึ่งธุรกรรมจริง (อย่างน้อยหนึ่งคำสั่งปิด) ทุกเดือน
                  </p>
                  <p>
                      ระยะเวลาต่ออายุ: คุณสามารถต่ออายุได้ในเดือนถัดไปหากคุณตรงตามเงื่อนไขการต่ออายุภายใน 30 วันก่อนหมดอายุ สามารถต่ออายุได้สูงสุดครั้งละหนึ่งเดือนเท่านั้น
                  </p>
                  <p>
                      การตรวจสอบเงื่อนไขการต่ออายุ: ตรวจสอบหลังจากเข้าสู่เว็บหรือแอป
                  </p>

                          <p class="bold t30 title">
                              4、เวอร์ชันพิเศษ (EA VPS Plus)
                          </p>
                  <p>
                      การกำหนดค่า: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      ราคา: ฟรี มีค่าธรรมเนียมการเปิดใช้งานที่จำเป็นในการเปิดใช้งานครั้งแรก สามารถใช้งานได้อย่างถาวรหลังจากเปิดใช้งาน
                  </p>
                  <p>
                      ข้อกำหนดในการใช้งาน: บัญชีซื้อขายจริงของนายหน้าจะต้องถูกผูกมัด (บัญชีซื้อขายจริงภายใต้เทรดเดอร์รายอื่นไม่ถูกต้อง) และต้องมีธุรกรรมอย่างน้อยหนึ่งรายการ (ต้องมีคำสั่งปิดอย่างน้อยหนึ่งคำสั่ง)
                  </p>
                  <p>
                    เงื่อนไขการใช้งานฟรี: อย่างน้อย 1 ล็อตต่อเดือน (100 ล็อตสำหรับบัญชีไมโคร) ของการซื้อขายจริงของโบรกเกอร์ เข้าสู่ระบบ VPS ใน 30 วันที่ผ่านมา
                  </p>
                  <p>
                      การตรวจสอบสภาพการใช้งานฟรี: ตรวจสอบหลังจากเข้าสู่ระบบเว็บหรือแอพ
                  </p>`,
        vi: `
        <div class="title-box">Phân loại sản phẩm VPS WikiFX</div>
                          <p class="bold title">
                              1、Phiên bản cơ bản (EA VPS)
                          </p>
                  <p>
                      Cấu hình: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Giá: $0.1USD
                  </p>
                  <p>
                      Yêu cầu sử dụng: Tài khoản giao dịch thực phải được ràng buộc trong vòng 7 ngày sau khi mở (tài khoản giao dịch thực tại bất kỳ đại lý nào cũng được chấp nhận) và phải có ít nhất một giao dịch (bắt buộc phải có ít nhất một lệnh đóng). Nếu không nó sẽ được tái chế.
                  </p>
                  <p>
                      Điều kiện gia hạn: ít nhất một giao dịch thực (ít nhất một lệnh đóng) mỗi tháng.
                  </p>
                  <p>
                      Thời gian gia hạn: Bạn có thể gia hạn cho tháng tiếp theo nếu đáp ứng các điều kiện gia hạn trong vòng 30 ngày trước khi hết hạn. Nó chỉ có thể được gia hạn tối đa một tháng một lần.
                  </p>
                  <p>
                      Phát hiện tình trạng gia hạn: Kiểm tra sau khi đăng nhập vào web hoặc ứng dụng.
                  </p>

                          <p class="bold title t30">
                              2、Phiên bản cao cấp (EA VPS Pro)
                          </p>
                  <p>
                      Cấu hình: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Giá: $6.99USD
                  </p>
                  <p>
                      Yêu cầu sử dụng: Phải có tài khoản giao dịch thật bị ràng buộc (tài khoản giao dịch thật của bất kỳ đại lý nào cũng được chấp nhận) và phải có ít nhất một giao dịch (bắt buộc phải có ít nhất một lệnh đóng).
                  </p>
                  <p>
                      Điều kiện gia hạn: ít nhất một giao dịch thực (ít nhất một lệnh đóng) mỗi tháng.
                  </p>
                  <p>
                      Thời gian gia hạn: Bạn có thể gia hạn cho tháng tiếp theo nếu đáp ứng các điều kiện gia hạn trong vòng 30 ngày trước khi hết hạn. Nó chỉ có thể được gia hạn tối đa một tháng một lần.
                  </p>
                  <p>
                      Phát hiện tình trạng gia hạn: Kiểm tra sau khi đăng nhập vào web hoặc ứng dụng.
                  </p>

                          <p class="bold title t30">
                              3、Phiên bản cTrader
                          </p>
                  <p>
                      Cấu hình: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Giá: $16.99USD
                  </p>
                  <p>
                      Yêu cầu sử dụng: Phải có tài khoản giao dịch thật bị ràng buộc (tài khoản giao dịch thật của bất kỳ đại lý nào cũng được chấp nhận) và phải có ít nhất một giao dịch (bắt buộc phải có ít nhất một lệnh đóng).
                  </p>
                  <p>
                      Điều kiện gia hạn: ít nhất một giao dịch thực (ít nhất một lệnh đóng) mỗi tháng.
                  </p>
                  <p>
                      Thời gian gia hạn: Bạn có thể gia hạn cho tháng tiếp theo nếu đáp ứng các điều kiện gia hạn trong vòng 30 ngày trước khi hết hạn. Nó chỉ có thể được gia hạn tối đa một tháng một lần.
                  </p>
                  <p>
                      Phát hiện tình trạng gia hạn: Kiểm tra sau khi đăng nhập vào web hoặc ứng dụng.
                  </p>

                          <p class="bold title t30">
                              4、Phiên bản độc quyền (EA VPS Plus)
                          </p>
                  <p>
                      Cấu hình: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Miễn phí. Có một khoản phí kích hoạt cần thiết để kích hoạt lần đầu tiên. Nó có thể được sử dụng vĩnh viễn sau khi kích hoạt.
                  </p>
                  <p>
                      Yêu cầu sử dụng: Tài khoản giao dịch thực của nhà môi giới phải bị ràng buộc (tài khoản giao dịch thực của các nhà giao dịch khác không hợp lệ) và phải có ít nhất một giao dịch (bắt buộc phải có ít nhất một lệnh đóng).
                  </p>
                  <p>
                    Điều kiện sử dụng miễn phí: ít nhất 1 lô mỗi tháng (100 lô đối với tài khoản vi mô) giao dịch thực của nhà môi giới đã đăng nhập vào VPS trong 30 ngày qua;
                  </p>
                  <p>
                      Phát hiện tình trạng sử dụng miễn phí: kiểm tra sau khi đăng nhập vào Web hoặc Ứng dụng.
                  </p>`,
        id: `
        <div class="title-box">Klasifikasi produk VPS WikiFX</div>
                          <p class="bold title">
                              1、Versi dasar (EA VPS)
                          </p>
                  <p>
                      Konfigurasi: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Harga: $0.1USD
                  </p>
                  <p>
                      Persyaratan penggunaan: Akun perdagangan nyata harus diikat dalam waktu 7 hari setelah pembukaan (akun perdagangan nyata di bawah dealer mana pun dapat diterima), dan harus ada setidaknya satu transaksi (setidaknya diperlukan satu perintah penutupan). Jika tidak maka akan didaur ulang.
                  </p>
                  <p>
                      Ketentuan perpanjangan: minimal satu transaksi nyata (minimal satu order penutupan) setiap bulan.
                  </p>
                  <p>
                      Periode perpanjangan: Anda dapat memperbarui untuk bulan berikutnya jika Anda memenuhi ketentuan perpanjangan dalam waktu 30 hari sebelum habis masa berlakunya. Itu hanya dapat diperpanjang untuk maksimal satu bulan pada satu waktu.
                  </p>
                  <p>
                      Deteksi kondisi pembaruan: Periksa setelah masuk ke web atau aplikasi.
                  </p>

                          <p class="bold title t30">
                              2、Versi kelas atas (EA VPS Pro)
                          </p>
                  <p>
                      Konfigurasi: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Harga: $6.99USD
                  </p>
                  <p>
                      Persyaratan penggunaan: Akun perdagangan nyata harus terikat (akun perdagangan nyata di bawah dealer mana pun dapat diterima), dan harus ada setidaknya satu transaksi (setidaknya diperlukan satu perintah penutupan).
                  </p>
                  <p>
                      Ketentuan perpanjangan: minimal satu transaksi nyata (minimal satu order penutupan) setiap bulan.
                  </p>
                  <p>
                      Periode perpanjangan: Anda dapat memperbarui untuk bulan berikutnya jika Anda memenuhi ketentuan perpanjangan dalam waktu 30 hari sebelum habis masa berlakunya. Itu hanya dapat diperpanjang untuk maksimal satu bulan pada satu waktu.
                  </p>
                  <p>
                      Deteksi kondisi pembaruan: Periksa setelah masuk ke web atau aplikasi.
                  </p>

                          <p class="bold title t30">
                              3、versi cTrader
                          </p>
                  <p>
                      Konfigurasi: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Harga: $16.99USD
                  </p>
                  <p>
                      Persyaratan penggunaan: Akun perdagangan nyata harus terikat (akun perdagangan nyata di bawah dealer mana pun dapat diterima), dan harus ada setidaknya satu transaksi (setidaknya diperlukan satu perintah penutupan).
                  </p>
                  <p>
                      Ketentuan perpanjangan: minimal satu transaksi nyata (minimal satu order penutupan) setiap bulan.
                  </p>
                  <p>
                      Periode perpanjangan: Anda dapat memperbarui untuk bulan berikutnya jika Anda memenuhi ketentuan perpanjangan dalam waktu 30 hari sebelum habis masa berlakunya. Itu hanya dapat diperpanjang untuk maksimal satu bulan pada satu waktu.
                  </p>
                  <p>
                      Deteksi kondisi pembaruan: Periksa setelah masuk ke web atau aplikasi.
                  </p>

                          <p class="bold title t30">
                              4、Versi eksklusif (EA VPS Plus)
                          </p>
                  <p>
                      Konfigurasi: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Harga: Gratis. Ada biaya aktivasi yang diperlukan untuk aktivasi pertama kali. Ini dapat digunakan secara permanen setelah aktivasi.
                  </p>
                  <p>
                      Persyaratan penggunaan: Akun perdagangan nyata broker harus terikat (akun perdagangan nyata di bawah pedagang lain tidak valid), dan harus ada setidaknya satu transaksi (setidaknya diperlukan satu perintah penutupan).
                  </p>
                  <p>
                    Ketentuan penggunaan gratis: minimal 1 lot per bulan (100 lot untuk akun mikro) dari perdagangan nyata broker yang login ke VPS dalam 30 hari terakhir
                  </p>
                  <p>
                      Deteksi kondisi penggunaan gratis: periksa setelah masuk ke Web atau Aplikasi.
                  </p>`,
        es: `
        <div class="title-box">Clasificación de productos WikiFX VPS</div>
                          <p class="bold title">
                              1、Versión básica (EA VPS)
                          </p>
                  <p>
                      Configuración: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Precio: $0.1USD
                  </p>
                  <p>
                      Requisitos de uso: una cuenta comercial real debe vincularse dentro de los 7 días posteriores a su apertura (se acepta una cuenta comercial real con cualquier distribuidor) y debe haber al menos una transacción (se requiere al menos una orden de cierre). De lo contrario será reciclado.
                  </p>
                  <p>
                      Condiciones de renovación: al menos una transacción real (al menos una orden de cierre) cada mes.
                  </p>
                  <p>
                      Periodo de renovación: Podrás renovar para el siguiente mes si cumples las condiciones de renovación dentro de los 30 días anteriores al vencimiento. Sólo se puede renovar por un máximo de un mes cada vez.
                  </p>
                  <p>
                      Detección de condición de renovación: Verifique después de iniciar sesión en la web o aplicación.
                  </p>

                          <p class="bold title t30">
                              2、Versión de gama alta (EA VPS Pro)
                          </p>
                  <p>
                      Configuración: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Precio: $6.99USD.
                  </p>
                  <p>
                      Requisitos de uso: se debe vincular una cuenta comercial real (se acepta una cuenta comercial real con cualquier distribuidor) y debe haber al menos una transacción (se requiere al menos una orden de cierre).
                  </p>
                  <p>
                      Condiciones de renovación: al menos una transacción real (al menos una orden de cierre) cada mes.
                  </p>
                  <p>
                      Periodo de renovación: Podrás renovar para el siguiente mes si cumples las condiciones de renovación dentro de los 30 días anteriores al vencimiento. Sólo se puede renovar por un máximo de un mes cada vez.
                  </p>
                  <p>
                      Detección de condición de renovación: Verifique después de iniciar sesión en la web o aplicación.
                  </p>

                          <p class="bold title t30">
                              3、Versión cTrader
                          </p>
                  <p>
                      Configuración: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Precio: $16.99USD.
                  </p>
                  <p>
                      Requisitos de uso: se debe vincular una cuenta comercial real (se acepta una cuenta comercial real con cualquier distribuidor) y debe haber al menos una transacción (se requiere al menos una orden de cierre).
                  </p>
                  <p>
                      Condiciones de renovación: al menos una transacción real (al menos una orden de cierre) cada mes.
                  </p>
                  <p>
                      Periodo de renovación: Podrás renovar para el siguiente mes si cumples las condiciones de renovación dentro de los 30 días anteriores al vencimiento. Sólo se puede renovar por un máximo de un mes cada vez.
                  </p>
                  <p>
                      Detección de condición de renovación: Verifique después de iniciar sesión en la web o aplicación.
                  </p>

                          <p class="bold title t30">
                              4、Versión exclusiva (EA VPS Plus)
                          </p>
                  <p>
                      Configuración: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Precio: Gratis. Se requiere una tarifa de activación para activar por primera vez. Se puede utilizar de forma permanente después de la activación.
                  </p>
                  <p>
                      Requisitos de uso: la cuenta comercial real del corredor debe estar vinculada (las cuentas comerciales reales de otros comerciantes no son válidas) y debe haber al menos una transacción (se requiere al menos una orden de cierre).
                  </p>
                  <p>
                    Condiciones de uso gratuito: al menos 1 lote por mes (100 lotes para microcuentas) de operaciones reales del corredor conectado al VPS en los últimos 30 días;
                  </p>
                  <p>
                      Detección de condiciones de uso gratuito: verifique después de iniciar sesión en la Web o App.
                  </p>`,
        hi: `
        <div class="title-box">WikiFX VPS उत्पाद वर्गीकरण</div>
                          <p class="bold">
                              1、मूल संस्करण (ईए वीपीएस)
                          </p>
                  <p>
                      कॉन्फ़िगरेशन: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      मूल्य: $0.1USD
                  </p>
                  <p>
                      उपयोग के लिए आवश्यकताएँ: एक वास्तविक ट्रेडिंग खाता खोलने के बाद 7 दिनों के भीतर बाध्य होना चाहिए (किसी भी डीलर के तहत एक वास्तविक ट्रेडिंग खाता स्वीकार्य है), और कम से कम एक लेनदेन होना चाहिए (कम से कम एक समापन आदेश आवश्यक है)। अन्यथा इसे रिसाइकिल किया जाएगा.
                  </p>
                  <p>
                      नवीनीकरण की शर्तें: हर महीने कम से कम एक वास्तविक लेनदेन (कम से कम एक समापन आदेश)।
                  </p>
                  <p>
                      नवीनीकरण अवधि: यदि आप समाप्ति से 30 दिनों के भीतर नवीनीकरण शर्तों को पूरा करते हैं तो आप अगले महीने के लिए नवीनीकरण कर सकते हैं। इसे एक बार में अधिकतम एक महीने के लिए ही नवीनीकृत किया जा सकता है।
                  </p>
                  <p>
                      नवीनीकरण स्थिति का पता लगाना: वेब या ऐप में लॉग इन करने के बाद जांचें।
                  </p>

                          <p class="bold title t30">
                              2、हाई-एंड संस्करण (ईए वीपीएस प्रो)
                          </p>
                  <p>
                      कॉन्फ़िगरेशन: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      मूल्य: $6.99USD
                  </p>
                  <p>
                      उपयोग के लिए आवश्यकताएँ: एक वास्तविक ट्रेडिंग खाता बाध्य होना चाहिए (किसी भी डीलर के तहत एक वास्तविक ट्रेडिंग खाता स्वीकार्य है), और कम से कम एक लेनदेन होना चाहिए (कम से कम एक समापन आदेश आवश्यक है)।
                  </p>
                  <p>
                      नवीनीकरण की शर्तें: हर महीने कम से कम एक वास्तविक लेनदेन (कम से कम एक समापन आदेश)।
                  </p>
                  <p>
                      नवीनीकरण अवधि: यदि आप समाप्ति से 30 दिनों के भीतर नवीनीकरण शर्तों को पूरा करते हैं तो आप अगले महीने के लिए नवीनीकरण कर सकते हैं। इसे एक बार में अधिकतम एक महीने के लिए ही नवीनीकृत किया जा सकता है।
                  </p>
                  <p>
                      नवीनीकरण स्थिति का पता लगाना: वेब या ऐप में लॉग इन करने के बाद जांचें।
                  </p>

                          <p class="bold title t30">
                              3、cTrader संस्करण
                          </p>
                  <p>
                      कॉन्फ़िगरेशन: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      मूल्य: $16.99USD
                  </p>
                  <p>
                      उपयोग के लिए आवश्यकताएँ: एक वास्तविक ट्रेडिंग खाता बाध्य होना चाहिए (किसी भी डीलर के तहत एक वास्तविक ट्रेडिंग खाता स्वीकार्य है), और कम से कम एक लेनदेन होना चाहिए (कम से कम एक समापन आदेश आवश्यक है)।
                  </p>
                  <p>
                      नवीनीकरण की शर्तें: हर महीने कम से कम एक वास्तविक लेनदेन (कम से कम एक समापन आदेश)।
                  </p>
                  <p>
                      नवीनीकरण अवधि: यदि आप समाप्ति से 30 दिनों के भीतर नवीनीकरण शर्तों को पूरा करते हैं तो आप अगले महीने के लिए नवीनीकरण कर सकते हैं। इसे एक बार में अधिकतम एक महीने के लिए ही नवीनीकृत किया जा सकता है।
                  </p>
                  <p>
                      नवीनीकरण स्थिति का पता लगाना: वेब या ऐप में लॉग इन करने के बाद जांचें।
                  </p>

                          <p class="bold title t30">
                              4、विशिष्ट संस्करण (ईए वीपीएस प्लस)
                          </p>
                  <p>
                      कॉन्फ़िगरेशन: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      कीमत: मुफ़्त. पहली बार सक्रिय करने के लिए एक सक्रियण शुल्क आवश्यक है। सक्रियण के बाद इसे स्थायी रूप से उपयोग किया जा सकता है।
                  </p>
                  <p>
                      उपयोग के लिए आवश्यकताएँ: ब्रोकर का वास्तविक ट्रेडिंग खाता बाध्य होना चाहिए (अन्य व्यापारियों के तहत वास्तविक ट्रेडिंग खाते अमान्य हैं), और कम से कम एक लेनदेन होना चाहिए (कम से कम एक समापन आदेश आवश्यक है)।
                  </p>
                  <p>
                    नि:शुल्क उपयोग की शर्तें: पिछले 30 दिनों में ब्रोकर की वास्तविक ट्रेडिंग का कम से कम 1 लॉट प्रति माह (माइक्रो खातों के लिए 100 लॉट);
                  </p>
                  <p>
                      नि:शुल्क उपयोग की स्थिति का पता लगाना: वेब या ऐप में लॉग इन करने के बाद जांचें।
                  </p>`,
        fil: `
        <div class="title-box">Pag-uuri ng produkto ng WikiFX VPS</div>
                          <p class="bold title">
                              1、Pangunahing bersyon (EA VPS)
                          </p>
                  <p>
                      Configuration: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Presyo: $0.1USD
                  </p>
                  <p>
                      Mga kinakailangan para sa paggamit: Ang isang tunay na trading account ay dapat na nakatali sa loob ng 7 araw pagkatapos ng pagbubukas (isang tunay na trading account sa ilalim ng anumang dealer ay katanggap-tanggap), at dapat mayroong hindi bababa sa isang transaksyon (kahit isang closing order ay kinakailangan). Kung hindi, ito ay ire-recycle.
                  </p>
                  <p>
                      Mga kundisyon sa pag-renew: hindi bababa sa isang tunay na transaksyon (kahit isang pagsasara ng order) bawat buwan.
                  </p>
                  <p>
                      Panahon ng pag-renew: Maaari kang mag-renew para sa susunod na buwan kung matutugunan mo ang mga kundisyon sa pag-renew sa loob ng 30 araw bago mag-expire. Maaari lamang itong i-renew sa loob ng maximum na isang buwan sa isang pagkakataon.
                  </p>
                  <p>
                      Pag-detect ng kundisyon sa pag-renew: Tingnan pagkatapos mag-log in sa web o app.
                  </p>

                          <p class="bold title t30">
                              2、High-end na bersyon (EA VPS Pro)
                          </p>
                  <p>
                      Configuration: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Presyo: $6.99USD
                  </p>
                  <p>
                      Mga kinakailangan para sa paggamit: Ang isang tunay na trading account ay dapat na nakatali (isang tunay na trading account sa ilalim ng anumang dealer ay katanggap-tanggap), at dapat mayroong kahit isang transaksyon (kahit isang closing order ang kinakailangan).
                  </p>
                  <p>
                      Mga kundisyon sa pag-renew: hindi bababa sa isang tunay na transaksyon (kahit isang pagsasara ng order) bawat buwan.
                  </p>
                  <p>
                      Panahon ng pag-renew: Maaari kang mag-renew para sa susunod na buwan kung matutugunan mo ang mga kundisyon sa pag-renew sa loob ng 30 araw bago mag-expire. Maaari lamang itong i-renew sa loob ng maximum na isang buwan sa isang pagkakataon.
                  </p>
                  <p>
                      Pag-detect ng kundisyon sa pag-renew: Tingnan pagkatapos mag-log in sa web o app.
                  </p>

                          <p class="bold title t30">
                              3、bersyon ng cTrader
                          </p>
                  <p>
                      Configuration: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Presyo: $16.99USD
                  </p>
                  <p>
                      Mga kinakailangan para sa paggamit: Ang isang tunay na trading account ay dapat na nakatali (isang tunay na trading account sa ilalim ng anumang dealer ay katanggap-tanggap), at dapat mayroong kahit isang transaksyon (kahit isang closing order ang kinakailangan).
                  </p>
                  <p>
                      Mga kundisyon sa pag-renew: hindi bababa sa isang tunay na transaksyon (kahit isang pagsasara ng order) bawat buwan.
                  </p>
                  <p>
                      Panahon ng pag-renew: Maaari kang mag-renew para sa susunod na buwan kung matutugunan mo ang mga kundisyon sa pag-renew sa loob ng 30 araw bago mag-expire. Maaari lamang itong i-renew sa loob ng maximum na isang buwan sa isang pagkakataon.
                  </p>
                  <p>
                      Pag-detect ng kundisyon sa pag-renew: Tingnan pagkatapos mag-log in sa web o app.
                  </p>

                          <p class="bold title t30">
                              4、Eksklusibong bersyon (EA VPS Plus)
                          </p>
                  <p>
                      Configuration: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Presyo: Libre. May activation fee na kailangan para makapag-activate sa unang pagkakataon. Maaari itong gamitin nang permanente pagkatapos ng pag-activate.
                  </p>
                  <p>
                      Mga kinakailangan para sa paggamit: Ang tunay na trading account ng broker ay dapat na nakatali (ang mga tunay na trading account sa ilalim ng ibang mga mangangalakal ay hindi wasto), at dapat mayroong kahit isang transaksyon (kahit isang closing order ang kinakailangan).
                  </p>
                  <p>
                    Mga kondisyon ng libreng paggamit: hindi bababa sa 1 lot bawat buwan (100 lot para sa mga micro account) ng tunay na kalakalan ng broker na naka-log in sa VPS sa nakalipas na 30 araw
                  </p>
                  <p>
                      Libreng pagtukoy sa kundisyon ng paggamit: tingnan pagkatapos mag-log in sa Web o App.
                  </p>`,
        fr: `
        <div class="title-box">Classification des produits WikiFX VPS</div>
                          <p class="bold title">
                              1、Version de base (EA VPS)
                          </p>
                  <p>
                      Configuration : 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Prix : $0.1USD
                  </p>
                  <p>
                      Conditions d&#39;utilisation&nbsp;: Un compte de trading réel doit être lié dans les 7 jours suivant son ouverture (un compte de trading réel auprès de n&#39;importe quel courtier est acceptable) et il doit y avoir au moins une transaction (au moins un ordre de clôture est requis). Sinon, il sera recyclé.
                  </p>
                  <p>
                      Conditions de renouvellement : au moins une transaction réelle (au moins un ordre de clôture) chaque mois.
                  </p>
                  <p>
                      Période de renouvellement : Vous pouvez renouveler pour le mois suivant si vous remplissez les conditions de renouvellement dans les 30 jours avant l&#39;expiration. Il ne peut être renouvelé que pour un mois maximum à la fois.
                  </p>
                  <p>
                      Détection des conditions de renouvellement&nbsp;: vérifiez après vous être connecté au Web ou à l&#39;application.
                  </p>

                          <p class="bold title t30">
                              2、Version haut de gamme (EA VPS Pro)
                          </p>
                  <p>
                      Configuration : 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Prix : $6.99USD
                  </p>
                  <p>
                      Conditions d&#39;utilisation&nbsp;: Un compte de trading réel doit être lié (un compte de trading réel auprès de n&#39;importe quel courtier est acceptable) et il doit y avoir au moins une transaction (au moins un ordre de clôture est requis).
                  </p>
                  <p>
                      Conditions de renouvellement : au moins une transaction réelle (au moins un ordre de clôture) chaque mois.
                  </p>
                  <p>
                      Période de renouvellement : Vous pouvez renouveler pour le mois suivant si vous remplissez les conditions de renouvellement dans les 30 jours avant l&#39;expiration. Il ne peut être renouvelé que pour un mois maximum à la fois.
                  </p>
                  <p>
                      Détection des conditions de renouvellement&nbsp;: vérifiez après vous être connecté au Web ou à l&#39;application.
                  </p>

                          <p class="bold title t30">
                              3、Version cTrader
                          </p>
                  <p>
                      Configuration : 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Prix : $16.99USD
                  </p>
                  <p>
                      Conditions d&#39;utilisation&nbsp;: Un compte de trading réel doit être lié (un compte de trading réel auprès de n&#39;importe quel courtier est acceptable) et il doit y avoir au moins une transaction (au moins un ordre de clôture est requis).
                  </p>
                  <p>
                      Conditions de renouvellement : au moins une transaction réelle (au moins un ordre de clôture) chaque mois.
                  </p>
                  <p>
                      Période de renouvellement : Vous pouvez renouveler pour le mois suivant si vous remplissez les conditions de renouvellement dans les 30 jours avant l&#39;expiration. Il ne peut être renouvelé que pour un mois maximum à la fois.
                  </p>
                  <p>
                      Détection des conditions de renouvellement&nbsp;: vérifiez après vous être connecté au Web ou à l&#39;application.
                  </p>

                          <p class="bold title t30">
                              4、Version exclusive (EA VPS Plus)
                          </p>
                  <p>
                      Configuration : 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Prix : Gratuit. Des frais d&#39;activation sont requis pour l&#39;activation pour la première fois. Il peut être utilisé de manière permanente après activation.
                  </p>
                  <p>
                      Conditions d&#39;utilisation&nbsp;: le compte de trading réel du courtier doit être lié (les comptes de trading réels d&#39;autres traders ne sont pas valides) et il doit y avoir au moins une transaction (au moins un ordre de clôture est requis).
                  </p>
                  <p>
                    Conditions d'utilisation gratuite: au moins 1 lot par mois (100 lots pour les micro-comptes) des transactions réelles du courtier connecté au VPS au cours des 30 derniers jours;
                  </p>
                  <p>
                      Détection gratuite des conditions d&#39;utilisation&nbsp;: vérifiez après vous être connecté au Web ou à l&#39;application.
                  </p>`,
        de: `
        <div class="title-box">WikiFX VPS-Produktklassifizierung</div>
                          <p class="bold title">
                              1、Basisversion (EA VPS)
                          </p>
                  <p>
                      Konfiguration: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Preis: $0.1USD
                  </p>
                  <p>
                      Voraussetzungen für die Nutzung: Ein echtes Handelskonto muss innerhalb von 7 Tagen nach Eröffnung gebunden sein (ein echtes Handelskonto bei jedem Händler ist akzeptabel) und es muss mindestens eine Transaktion vorliegen (mindestens eine Schließungsorder ist erforderlich). Andernfalls wird es recycelt.
                  </p>
                  <p>
                      Verlängerungsbedingungen: mindestens eine echte Transaktion (mindestens ein Abschlussauftrag) jeden Monat.
                  </p>
                  <p>
                      Verlängerungszeitraum: Sie können für den nächsten Monat verlängern, wenn Sie die Verlängerungsbedingungen innerhalb von 30 Tagen vor Ablauf erfüllen. Es kann jeweils nur für maximal einen Monat verlängert werden.
                  </p>
                  <p>
                      Erkennung der Verlängerungsbedingung: Überprüfen Sie diese nach der Anmeldung im Web oder in der App.
                  </p>

                          <p class="bold title t30">
                              2、High-End-Version (EA VPS Pro)
                          </p>
                  <p>
                      Konfiguration: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Preis: $6.99USD
                  </p>
                  <p>
                      Voraussetzungen für die Nutzung: Ein echtes Handelskonto muss gebunden sein (ein echtes Handelskonto bei jedem Händler ist akzeptabel) und es muss mindestens eine Transaktion vorliegen (mindestens eine Abschlussorder ist erforderlich).
                  </p>
                  <p>
                      Verlängerungsbedingungen: mindestens eine echte Transaktion (mindestens ein Abschlussauftrag) jeden Monat.
                  </p>
                  <p>
                      Verlängerungszeitraum: Sie können für den nächsten Monat verlängern, wenn Sie die Verlängerungsbedingungen innerhalb von 30 Tagen vor Ablauf erfüllen. Es kann jeweils nur für maximal einen Monat verlängert werden.
                  </p>
                  <p>
                      Erkennung der Verlängerungsbedingung: Überprüfen Sie diese nach der Anmeldung im Web oder in der App.
                  </p>

                          <p class="bold title t30">
                              3、cTrader-Version
                          </p>
                  <p>
                      Konfiguration: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Preis: $16.99USD
                  </p>
                  <p>
                      Voraussetzungen für die Nutzung: Ein echtes Handelskonto muss gebunden sein (ein echtes Handelskonto bei jedem Händler ist akzeptabel) und es muss mindestens eine Transaktion vorliegen (mindestens eine Abschlussorder ist erforderlich).
                  </p>
                  <p>
                      Verlängerungsbedingungen: mindestens eine echte Transaktion (mindestens ein Abschlussauftrag) jeden Monat.
                  </p>
                  <p>
                      Verlängerungszeitraum: Sie können für den nächsten Monat verlängern, wenn Sie die Verlängerungsbedingungen innerhalb von 30 Tagen vor Ablauf erfüllen. Es kann jeweils nur für maximal einen Monat verlängert werden.
                  </p>
                  <p>
                      Erkennung der Verlängerungsbedingung: Überprüfen Sie diese nach der Anmeldung im Web oder in der App.
                  </p>

                          <p class="bold title t30">
                              4、Exklusive Version (EA VPS Plus)
                          </p>
                  <p>
                      Konfiguration: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Kostenlos. Für die erstmalige Aktivierung fällt eine Aktivierungsgebühr an. Nach der Aktivierung kann es dauerhaft genutzt werden.
                  </p>
                  <p>
                      Voraussetzungen für die Nutzung: Das echte Handelskonto des Brokers muss gebunden sein (echte Handelskonten unter anderen Händlern sind ungültig) und es muss mindestens eine Transaktion vorliegen (mindestens eine Abschlussorder ist erforderlich).
                  </p>
                  <p>
                    Kostenlose Nutzungsbedingungen: Mindestens 1 Lot pro Monat (100 Lots für Mikrokonten) des in den letzten 30 Tagen bei VPS angemeldeten realen Handels
                  </p>
                  <p>
                      Kostenlose Erkennung der Nutzungsbedingungen: Überprüfung nach der Anmeldung im Web oder in der App.
                  </p>`,
        pt: `
        <div class="title-box">Classificação de produto WikiFX VPS</div>
                          <p class="bold title">
                              1、Versão básica (EA VPS)
                          </p>
                  <p>
                      Configuração: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Preço: $0.1USD
                  </p>
                  <p>
                      Requisitos para uso: Uma conta de negociação real deve ser vinculada dentro de 7 dias após a abertura (uma conta de negociação real sob qualquer revendedor é aceitável) e deve haver pelo menos uma transação (é necessária pelo menos uma ordem de fechamento). Caso contrário, será reciclado.
                  </p>
                  <p>
                      Condições de renovação: pelo menos uma transação real (pelo menos uma ordem de fechamento) por mês.
                  </p>
                  <p>
                      Período de renovação: você pode renovar para o próximo mês se atender às condições de renovação 30 dias antes do vencimento. Só pode ser renovado por no máximo um mês de cada vez.
                  </p>
                  <p>
                      Detecção de condição de renovação: verifique após fazer login na web ou aplicativo.
                  </p>

                          <p class="bold title t30">
                              2、Versão topo de linha (EA VPS Pro)
                          </p>
                  <p>
                      Configuração: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Preço: $6.99USD
                  </p>
                  <p>
                      Requisitos para uso: Uma conta de negociação real deve estar vinculada (uma conta de negociação real sob qualquer revendedor é aceitável) e deve haver pelo menos uma transação (é necessária pelo menos uma ordem de fechamento).
                  </p>
                  <p>
                      Condições de renovação: pelo menos uma transação real (pelo menos uma ordem de fechamento) por mês.
                  </p>
                  <p>
                      Período de renovação: você pode renovar para o próximo mês se atender às condições de renovação 30 dias antes do vencimento. Só pode ser renovado por no máximo um mês de cada vez.
                  </p>
                  <p>
                      Detecção de condição de renovação: verifique após fazer login na web ou aplicativo.
                  </p>

                          <p class="bold title t30">
                              3、Versão cTrader
                          </p>
                  <p>
                      Configuração: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Preço: $16.99USD
                  </p>
                  <p>
                      Requisitos para uso: Uma conta de negociação real deve ser vinculada (uma conta de negociação real sob qualquer revendedor é aceitável) e deve haver pelo menos uma transação (é necessária pelo menos uma ordem de fechamento).
                  </p>
                  <p>
                      Condições de renovação: pelo menos uma transação real (pelo menos uma ordem de fechamento) por mês.
                  </p>
                  <p>
                      Período de renovação: você pode renovar para o próximo mês se atender às condições de renovação 30 dias antes do vencimento. Só pode ser renovado por no máximo um mês de cada vez.
                  </p>
                  <p>
                      Detecção de condição de renovação: verifique após fazer login na web ou aplicativo.
                  </p>

                          <p class="bold title t30">
                              4、Versão exclusiva (EA VPS Plus)
                          </p>
                  <p>
                      Configuração: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Preço: Grátis. É necessária uma taxa de ativação para ativar pela primeira vez. Pode ser usado permanentemente após a ativação.
                  </p>
                  <p>
                      Requisitos para uso: A conta de negociação real da corretora deve estar vinculada (contas de negociação reais de outros traders são inválidas) e deve haver pelo menos uma transação (é necessária pelo menos uma ordem de fechamento).
                  </p>
                  <p>
                    Condições de uso gratuito: pelo menos 1 lote por mês (100 lotes para micro contas) de negociação real da corretora logada no VPS nos últimos 30 dias;
                  </p>
                  <p>
                      Detecção gratuita de condições de uso: verifique após fazer login na Web ou aplicativo.
                  </p>`,
        tr: `
        <div class="title-box">WikiFX VPS ürün sınıflandırması</div>
                          <p class="bold title">
                              1、Temel sürüm (EA VPS)
                          </p>
                  <p>
                      Yapılandırma: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      Fiyat: $0.1USD
                  </p>
                  <p>
                      Kullanım gereksinimleri: Gerçek bir yatırım hesabı, açılıştan sonraki 7 gün içinde bağlanmalıdır (herhangi bir bayi altında gerçek bir yatırım hesabı kabul edilebilir) ve en az bir işlem olmalıdır (en az bir kapatma emri gereklidir). Aksi takdirde geri dönüştürülecektir.
                  </p>
                  <p>
                      Yenileme koşulları: her ay en az bir gerçek işlem (en az bir kapanış emri).
                  </p>
                  <p>
                      Yenileme süresi: Sürenin bitimine 30 gün kala yenileme koşullarını yerine getirmeniz durumunda bir sonraki ay için yenileme yapabilirsiniz. Bir defada en fazla bir ay süreyle yenilenebilir.
                  </p>
                  <p>
                      Yenileme durumu tespiti: Web&#39;de veya uygulamada oturum açtıktan sonra kontrol edin.
                  </p>

                          <p class="bold title t30">
                              2、Üst düzey sürüm (EA VPS Pro)
                          </p>
                  <p>
                      Yapılandırma: 2*CPU，2G*RAM，60G*HDD，1M*ADSL
                  </p>
                  <p>
                      Fiyat: $6.99USD
                  </p>
                  <p>
                      Kullanım gereksinimleri: Gerçek bir yatırım hesabı bağlı olmalıdır (herhangi bir bayi altında gerçek bir yatırım hesabı kabul edilebilir) ve en az bir işlem olmalıdır (en az bir kapatma emri gereklidir).
                  </p>
                  <p>
                      Yenileme koşulları: her ay en az bir gerçek işlem (en az bir kapanış emri).
                  </p>
                  <p>
                      Yenileme süresi: Sürenin bitimine 30 gün kala yenileme koşullarını yerine getirmeniz durumunda bir sonraki ay için yenileme yapabilirsiniz. Bir defada en fazla bir ay süreyle yenilenebilir.
                  </p>
                  <p>
                      Yenileme durumu tespiti: Web&#39;de veya uygulamada oturum açtıktan sonra kontrol edin.
                  </p>

                          <p class="bold title t30">
                              3、cTrader sürümü
                          </p>
                  <p>
                      Yapılandırma: 2*CPU，4G*RAM，100G*HDD，2M*ADSL
                  </p>
                  <p>
                      Fiyat: $16.99USD
                  </p>
                  <p>
                      Kullanım gereksinimleri: Gerçek bir yatırım hesabı bağlı olmalıdır (herhangi bir bayi altında gerçek bir yatırım hesabı kabul edilebilir) ve en az bir işlem olmalıdır (en az bir kapatma emri gereklidir).
                  </p>
                  <p>
                      Yenileme koşulları: her ay en az bir gerçek işlem (en az bir kapanış emri).
                  </p>
                  <p>
                      Yenileme süresi: Sürenin bitimine 30 gün kala yenileme koşullarını yerine getirmeniz durumunda bir sonraki ay için yenileme yapabilirsiniz. Bir defada en fazla bir ay süreyle yenilenebilir.
                  </p>
                  <p>
                      Yenileme durumu tespiti: Web&#39;de veya uygulamada oturum açtıktan sonra kontrol edin.
                  </p>

                          <p class="bold title t30">
                              4、Özel sürüm (EA VPS Plus)
                          </p>
                  <p>
                      Yapılandırma: 2*CPU，2G*RAM，60G*HDD，2M*ADSL
                  </p>
                  <p>
                      Fiyat: Ücretsiz. İlk kez etkinleştirmek için bir aktivasyon ücreti gereklidir. Aktivasyondan sonra kalıcı olarak kullanılabilir.
                  </p>
                  <p>
                      Kullanım gereksinimleri: Brokerın gerçek ticari hesabı bağlı olmalıdır (diğer yatırımcıların altındaki gerçek ticari hesaplar geçersizdir) ve en az bir işlem olmalıdır (en az bir kapatma emri gereklidir).
                  </p>
                  <p>
                    Ücretsiz kullanım koşulları: Brokerın son 30 gün içinde VPS'ye giriş yaptığı gerçek ticaretin ayda en az 1 lotu (mikro hesaplar için 100 lot);
                  </p>
                  <p>
                      Ücretsiz kullanım durumu tespiti: Web veya Uygulamada oturum açtıktan sonra kontrol edin.
                  </p>`,
        ko: `
        <div class="title-box">WikiFX VPS 제품 분류</div>
                          <p class="bold title">
                              1、기본 버전(EA VPS)
                          </p>
                  <p>
                      구성: 1*CPU，1G*RAM，40G*HDD，1M*ADSL
                  </p>
                  <p>
                      가격 : $0.1USD
                  </p>
                  <p>
                      사용 요구 사항: 실제 거래 계좌는 개설 후 7일 이내에 연결되어야 하며(모든 딜러의 실제 거래 계좌는 허용됨) 최소 1건의 거래가 있어야 합니다(최소 1건의 마감 주문이 필요함). 그렇지 않으면 재활용됩니다.
                  </p>
                  <p>
                      갱신 조건: 매월 최소 1건의 실제 거래(최소 1건의 마감 주문).
                  </p>
                  <p>
                      갱신 기간 : 만료 전 30일 이내에 갱신 조건을 충족하면 다음 달부터 갱신할 수 있습니다. 한 번에 최대 한 달 동안만 갱신할 수 있습니다.
                  </p>
                  <p>
                      갱신 조건 감지 : 웹 또는 앱에 로그인 후 확인하세요.
                  </p>

                          <p class="bold title t30">
                              2、하이엔드 버전(EA VPS Pro)
                          </p>
                  <p>
                      구성: 2*CPU，2G*RAM，60G*HDD，1M*ADSL.
                  </p>
                  <p>
                      가격 : $6.99USD
                  </p>
                  <p>
                      사용 요구 사항: 실제 거래 계좌가 연결되어 있어야 하며(모든 딜러의 실제 거래 계좌가 허용됨), 최소 하나의 거래가 있어야 합니다(최소 하나의 마감 주문이 필요함).
                  </p>
                  <p>
                      갱신 조건: 매월 최소 1건의 실제 거래(최소 1건의 마감 주문).
                  </p>
                  <p>
                      갱신 기간 : 만료 전 30일 이내에 갱신 조건을 충족하면 다음 달부터 갱신할 수 있습니다. 한 번에 최대 한 달 동안만 갱신할 수 있습니다.
                  </p>
                  <p>
                      갱신 조건 감지 : 웹 또는 앱에 로그인 후 확인하세요.
                  </p>

                          <p class="bold title t30">
                              3、cTrader 버전
                          </p>
                  <p>
                      구성: 2*CPU，4G*RAM，100G*HDD，2M*ADSL.
                  </p>
                  <p>
                      가격 : $16.99USD
                  </p>
                  <p>
                      사용 요구 사항: 실제 거래 계좌가 연결되어 있어야 하며(모든 딜러의 실제 거래 계좌가 허용됨), 최소 하나의 거래가 있어야 합니다(최소 하나의 마감 주문이 필요함).
                  </p>
                  <p>
                      갱신 조건: 매월 최소 1건의 실제 거래(최소 1건의 마감 주문).
                  </p>
                  <p>
                      갱신 기간 : 만료 전 30일 이내에 갱신 조건을 충족하면 다음 달부터 갱신할 수 있습니다. 한 번에 최대 한 달 동안만 갱신할 수 있습니다.
                  </p>
                  <p>
                      갱신 조건 감지 : 웹 또는 앱에 로그인 후 확인하세요.
                  </p>

                          <p class="bold title t30">
                              4、독점 버전(EA VPS Plus)
                          </p>
                  <p>
                      구성: 2*CPU，2G*RAM，60G*HDD，2M*ADSL.
                  </p>
                  <p>
                      가격: 무료. 처음 활성화하려면 활성화 비용이 필요합니다. 활성화 후 영구적으로 사용할 수 있습니다.
                  </p>
                  <p>
                      사용 요구사항: 브로커의 실제 거래 계좌가 바인딩되어 있어야 하며(다른 거래자의 실제 거래 계좌는 유효하지 않음), 거래가 하나 이상 있어야 합니다(마감 주문이 하나 이상 필요함).
                  </p>
                  <p>
                    무료 사용 조건: 지난 30일 동안 VPS에 로그인한 브로커의 실제 거래 중 최소 월 1랏(소액 계좌의 경우 100랏)
                  </p>
                  <p>
                      무료 이용조건 감지 : 웹, 앱 로그인 후 확인하세요.
                  </p>`,
        ar: `
        <div class="title-box">تصنيف منتجات WikiFX VPS</div>
                          <p class="bold title">
                              1、الإصدار الأساسي (EA VPS)
                          </p>
                  <p>
                    *CPU，1G*RAM，40G*HDD，1M*ADSL :التكوين
                  </p>
                  <p>
                    $0.1USD :السعر
                  </p>
                  <p>
                      متطلبات الاستخدام: يجب أن يكون حساب التداول الحقيقي مقيدًا خلال 7 أيام بعد فتحه (يُقبل حساب تداول حقيقي لدى أي تاجر)، ويجب أن تكون هناك معاملة واحدة على الأقل (مطلوب أمر إغلاق واحد على الأقل). وإلا سيتم إعادة تدويرها.
                  </p>
                  <p>
                      شروط التجديد: معاملة حقيقية واحدة على الأقل (أمر إغلاق واحد على الأقل) كل شهر.
                  </p>
                  <p>
                      فترة التجديد: يمكنك التجديد للشهر التالي إذا استوفيت شروط التجديد خلال 30 يومًا قبل انتهاء الصلاحية. ولا يمكن تجديدها إلا لمدة أقصاها شهر واحد في المرة الواحدة.
                  </p>
                  <p>
                      الكشف عن حالة التجديد: تحقق بعد تسجيل الدخول إلى الويب أو التطبيق.
                  </p>

                          <p class="bold title t30">
                              2、الإصدار المتقدم (EA VPS Pro)
                          </p>
                  <p>
                    2*CPU，2G*RAM，60G*HDD，1M*ADSL :التكوين
                  </p>
                  <p>
                    $6.99USD :السعر
                  </p>
                  <p>
                      متطلبات الاستخدام: يجب أن يكون حساب التداول الحقيقي مقيدًا (يُقبل حساب تداول حقيقي لدى أي تاجر)، ويجب أن تكون هناك معاملة واحدة على الأقل (مطلوب أمر إغلاق واحد على الأقل).
                  </p>
                  <p>
                      شروط التجديد: معاملة حقيقية واحدة على الأقل (أمر إغلاق واحد على الأقل) كل شهر.
                  </p>
                  <p>
                      فترة التجديد: يمكنك التجديد للشهر التالي إذا استوفيت شروط التجديد خلال 30 يومًا قبل انتهاء الصلاحية. ولا يمكن تجديدها إلا لمدة أقصاها شهر واحد في المرة الواحدة.
                  </p>
                  <p>
                      الكشف عن حالة التجديد: تحقق بعد تسجيل الدخول إلى الويب أو التطبيق.
                  </p>

                          <p class="bold title t30">
                              نسخة、3 cTrader
                          </p>
                  <p>
                    2*CPU，4G*RAM，100G*HDD，2M*ADSL :التكوين
                  </p>
                  <p>
                    $16.99USD :السعر
                  </p>
                  <p>
                      متطلبات الاستخدام: يجب أن يكون حساب التداول الحقيقي مقيدًا (يُقبل حساب تداول حقيقي لدى أي تاجر)، ويجب أن تكون هناك معاملة واحدة على الأقل (مطلوب أمر إغلاق واحد على الأقل).
                  </p>
                  <p>
                      شروط التجديد: معاملة حقيقية واحدة على الأقل (أمر إغلاق واحد على الأقل) كل شهر.
                  </p>
                  <p>
                      فترة التجديد: يمكنك التجديد للشهر التالي إذا استوفيت شروط التجديد خلال 30 يومًا قبل انتهاء الصلاحية. ولا يمكن تجديدها إلا لمدة أقصاها شهر واحد في المرة الواحدة.
                  </p>
                  <p>
                      الكشف عن حالة التجديد: تحقق بعد تسجيل الدخول إلى الويب أو التطبيق.
                  </p>

                          <p class="bold title t30">
                              4、النسخة الحصرية (EA VPS Plus)
                          </p>
                  <p>
                    2*CPU，2G*RAM，60G*HDD，2M*ADSL :التكوين
                  </p>
                  <p>
                      مجاني. هناك رسوم تفعيل مطلوبة للتفعيل لأول مرة. ويمكن استخدامه بشكل دائم بعد التنشيط.
                  </p>
                  <p>
                      متطلبات الاستخدام: يجب أن يكون حساب التداول الحقيقي للوسيط مقيدًا (حسابات التداول الحقيقية التابعة للمتداولين الآخرين غير صالحة)، ويجب أن تكون هناك معاملة واحدة على الأقل (مطلوب أمر إغلاق واحد على الأقل).
                  </p>
                  <p>
                    شروط الاستخدام المجاني: لوت واحد على الأقل شهريًا (100 لوت للحسابات الصغيرة) من التداول الحقيقي للوسيط الذي تم تسجيل دخوله إلى VPS خلال الثلاثين يومًا الماضية
                  </p>
                  <p>
                      الكشف عن حالة الاستخدام مجانًا: تحقق بعد تسجيل الدخول إلى الويب أو التطبيق.
                  </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40596'),
      meta: [
        { name: 'Description', content: this.$t('40594') }
      ]
    }
  }
}
